module.exports = "/fonts/Simple-Line-Icons.ttf?d2285965fe34b05465047401b8595dd0";